<template>
  <VueSlickCarousel
    ref="slick"
    v-bind="slickOptions"
    class="modal-product-slick px-lg-3"
    v-if="singleProduct && singleProduct.images.length"
  >
    <div
      class="slick-item px-lg-2"
      v-for="(image, index) in singleProduct.images"
      :key="index"
    >
      <div
        class="product-img"
        :style="{
          background: 'url(' + image + ')',
        }"
        @click="setMainImage(singleProduct, image)"
      >
        <div class="slide-no-mobile d-lg-none">
          <span class="font-12">1/18</span>
        </div>
      </div>
    </div>
    <!--div
      class="slick-item px-md-3"
      v-for="(image, index) in singleProduct.images"
      :key="index"
    >
      <div
        class="product-img"
        :style="{
          background: 'url(' + image + ')',
        }"
      ></div>
    </div-->
  </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";

export default {
  name: "ModalProductSlick",
  props: ["singleProduct"],
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      slickOptions: {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  methods: {
    setMainImage: function (item, image) {
      item.main_image = image;
    },
  },
};
</script>
